import React from 'react';
import PropTypes from 'prop-types';
import OfficePageListItem from './OfficePageListItem';
import Styles from './OfficePageList.scss';
import { goToOfficePage, setCookieResellerId } from '../helpers';

const OfficePageList = ({ selectedOffice, offices }) => {
  const onChooseOffice = React.useCallback((office) => {
    goToOfficePage(office);
    setCookieResellerId(office);
  }, []);

  return (
    <div className={Styles.list}>
      {Object.keys(offices).map((city) => (
        <OfficePageListItem
          key={city}
          city={city}
          selectedOffice={selectedOffice}
          offices={offices[city]}
          chooseOffice={onChooseOffice}
        />
      ))}
    </div>
  );
};

OfficePageList.propTypes = {
  selectedOffice: PropTypes.number,
  offices: PropTypes.object
};

export default OfficePageList;
